import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from './reportsMessages';

import './Scale.scss';

export const colors = ['#FF836A', '#FFAF2E', '#BEE94B', '#59E6AA', '#0DD396'];

const Scale = props => {

  const gradeScale = props.gradeScale ? props.gradeScale : false;

  return (
    <Fragment>
      <div className="Scale">
        <strong>
          <FormattedMessage {...messages.scale} />:
        </strong>
        <div className="squares mt-2">
          {colors.map(color => (
            <div className="square" style={{ backgroundColor: color }} />
          ))}
        </div>
        <div className="legend-scale">
          {/* <span style={{ width: '25px' }}> */}
          <span>
            {gradeScale ? gradeScale.min : "0%"}
          </span>
          {/* <span style={{ width: '25px' }}> */}
          <span>
            {gradeScale ? gradeScale.max : "100%"}
          </span>
        </div>
      </div>
    </Fragment>
  );
};

Scale.propTypes = {};

export default Scale;
